import React from 'react'
import { useViewport, viewportBreakpoint } from '../../../utils';
import { ProgramProfile } from './form-program-profile';
import { DateLocation } from './form-date-location';
// import { FormMilestone } from './form-milestone';
// import { FormJourney } from './form-journey';
// import { FormBeneficiaries } from './form-beneficiaries';
// import { FormStory } from './form-story';
// import { FormTestimoni } from './form-testimoni';
// import { FormRelated } from './form-related';
// import { FormGallery } from './form-gallery';

const Form = () => {
  const [form, setForm] = React.useState({
    date_visibility: 'public',
    milestone_visibility: 'public',
    journey_visibility: 'public',
    beneficiaries_visibility: 'public',
    impact_visibility: 'public',
  })

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <form>
      <div className="lg:hidden mobile-fullwidth">
        <div className="p-6 mb-8 text-center" style={{background: '#f5f5f5'}}>
          <p className="text-sm text-gray-444 mb-3">Status: <strong>Published</strong></p>
          <p className="text-sm text-gray-444">Inisatif Status: <span style={{color: '#FF5448'}}>Ongoing</span></p>
        </div>
      </div>

      <ProgramProfile form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8 lg:my-10"/>

      <DateLocation form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8 lg:my-10"/>

      {/* <FormMilestone form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8 lg:my-10"/>

      <FormJourney form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8 lg:my-10"/>

      <FormBeneficiaries form={form} updateForm={updateForm} isMobile={isMobile}/>

      <hr className="my-8 lg:my-10"/>

      <FormStory />

      <hr className="my-8 lg:my-10"/>

      <FormGallery />

      <hr className="my-8 lg:my-10"/>

      <FormTestimoni />

      <hr className="my-8 lg:my-10"/>

      <FormRelated /> */}
    </form>
  )
}

export { Form }
